// @owners { team: patients-team }
import { type ReduxStateShared } from '~shared/store';

export const getAddFamilyMemberRelationship = (state: ReduxStateShared) => state.ui.addFamilyMember.relationship;
